import React from 'react'

const WhyUs = () => {
    return (
        <div className="flex flex-col gap-[64px] pb-[96px] max-2xl:px-[7.7vw] max-w-[1600px]">
            <div className="flex flex-col gap-[20px] max-w-[768px]">
                <div className="flex flex-col gap-[12px]">
                    <span className='text-[#F02E49] font-[600] '>
                        Why Choose us
                    </span>
                    <h2 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] '>
                        Elevate Your DJ Journey with Certified DJ’s Support.
                    </h2>
                </div>
                <span className='text-[#475467] sm:text-[20px] text-[16px] '>
                    Seamless Operations, Unleashed Creativity
                </span>
            </div>
            <div className="flex max-md:flex-col items-start gap-[64px]">
                <p className='w-full text-[18px] text-[#475467`]'>
                    In today’s vibrant music industry, DJs are more than just performers they’re entrepreneurs, marketers, and event organizers. The balancing act between spinning tracks and spinning plates of business tasks can be overwhelming, detracting from the art of music itself.
                    <br />
                    <br />
                    Certified DJs is here to streamline your multitasking mix. We provide comprehensive support that allows you to concentrate on your passion for music while we handle the business operations.
                    <br />
                    <br />
                    Our services include marketing assistance, business management, booking support, and a reliable payment system that ensures you get paid on time, every time.
                </p>
                <p className='w-full text-[18px] text-[#475467`]'>
                    Say goodbye to the hassle of unpaid invoices. With Certified DJs, your career is set on a stable, enjoyable, and financially secure path freeing you to focus on creating unforgettable musical experiences.
                </p>
            </div>
        </div>
    )
}

export default WhyUs